export const LOCALIZATION_SCOPE = 'account-users';
